import { Component, OnInit } from "@angular/core";
import { MyAccountService } from "../my-account.service";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import * as CryptoJS from "crypto-js";
import { MatDialog } from "@angular/material/dialog";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { Router } from "@angular/router";
@Component({
  selector: "app-my-profile",
  templateUrl: "./my-profile.component.html",
  styleUrls: ["./my-profile.component.css"],
})
export class MyProfileComponent implements OnInit {
  data: any;
  profile: any;
  isActive = false;
  appConstant: any;
  constructor(
    public profileService: MyAccountService,
    private spinner: NgxSpinnerService,
    public translate: TranslateService,
    public dialog: MatDialog,
    private router: Router
  ) {
    // translate.setDefaultLang("en");
    // translate.use("en");
    // translate.addLangs(["en", "es"]);
  }

  ngOnInit(): void {
    this.appConstant = environment;
    this.spinner.show();
    this.getProfile();
    this.isActive = true;

    // this.profileService.getProfile().subscribe(
    //   (res) => {
    //     if (res) {
    //       this.data = res;
    //       this.spinner.hide();
    //     }
    //   },
    //   (err) => {
    //   }
    // );
  }

  openDialog() {
    const dialogRef = this.dialog.open(EditProfileComponent, {
      panelClass: "edit-model",
    });
    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }

  getProfile() {
    if (localStorage.getItem(environment.localStorageKey)) {
      const userInfo = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem(environment.localStorageKey),
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
      this.data = userInfo;
    }

    this.spinner.hide();
  }

  errorHandler(event) {
    event.target.src = environment.userNoImage;
  }
  remove() {
    this.isActive = false;
    this.profileService.isActive = false;
  }
}
